import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  appPageContent: {
    display: "grid",
    borderLeft: "1px solid #eeeeee"
  },
  header: {
    height: theme.heightDesktopPageHeader,
    boxShadow: "3px 1px 7px 0px rgba(0, 0, 0, 0.15)"
  },
  container: {
    flex: "auto",
    width: "100%",
    overflow: "auto",
    position: "relative"
  },
  topBar: {
    display: "flex",
    alignItems: "center",
    borderRadius: 0,
    padding: "20px 24px",
    [theme.breakpoints.down("sm")]: {
      padding: 16
    }
  },
  topBarTitle: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 19,
    [theme.breakpoints.down("sm")]: {
      marginBottom: 12
    }
  },
  cancelButtonWrapper: {
    textAlign: "right"
  },
  cancelButton: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: theme.palette.text.secondary,

    fontSize: 16,
    textDecoration: "none",
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      top: 12,
      right: 16
    }
  },
  progress: {
    textAlign: "center"
  },
  list: {
    width: "100%",
    backgroundColor: theme.palette.common.white
  },
  rowLink: {
    textDecoration: "none"
  },
  row: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: 60,
    paddingLeft: 24,
    paddingRight: 24,
    borderBottom: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 24,
      paddingRight: 16
    }
  },
  icon: {
    height: 16,
    color: theme.palette.text.hint,
    marginBottom: -2,
    marginRight: 10
  },
  name: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    lineHeight: "normal",
    color: theme.palette.text.primary
  },
  age: {
    fontSize: 14,
    lineHeight: "normal",
    textAlign: "right"
  },
  color: {
    fontSize: 14,
    fontWeight: "bold",
    lineHeight: "normal",
    textAlign: "right"
  },
  shadow: {
    boxShadow: "3px 1px 7px 0px rgba(0, 0, 0, 0.15)"
  },
  gridRoot: {
    height: "100%",
    padding: "0 16px",
    [theme.breakpoints.up("sm")]: {
      padding: "0 24px"
    }
  },
  gridItem: {
    "& > .MuiGrid-item": {
      [theme.breakpoints.down("xs")]: {
        paddingTop: 0,
        paddingBottom: 10
      }
    }
  },
  infiniteLoader: {
    display: "none",
    position: "absolute",
    width: "100%",
    height: "calc(100dvh - 124px)",
    [theme.breakpoints.down("xs")]: {
      padding: 16,
      height: "calc(100dvh - 116px)"
    }
  },
  showInfiniteLoader: {
    display: "flex",
    alignItems: "flex-end",
    paddingBottom: 40
  },
  showOverlayLoader: {
    display: "flex",
    maxWidth: "100%",
    width: "100%",
    height: "100%",
    left: 0,
    margin: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.9)"
  },
  search: {
    flex: "auto",
    padding: "0 12px",
    [theme.breakpoints.up("md")]: {
      flex: "auto",
      maxWidth: "400px"
    }
  },
  searchItem: {
    height: 32,
    display: "flex",
    alignItems: "center"
  },
  searchItemIconWrapper: {
    minWidth: 12,
    marginRight: 16
  },
  searchItemIcon: {
    fontSize: 14,
    color: theme.palette.text.hint
  },
  searchItemText: {
    fontSize: 15
  },
  appSearch: {
    [theme.breakpoints.up("md")]: {
      margin: "0 auto"
    }
  }
}));
